<p-galleria *ngIf="images && property" [value]="images" (click)="showFullScreen($event)" (activeIndexChange)="activeIndexChange($event)" [autoPlay]="true" [circular]="true" [responsiveOptions]="responsiveOptions" [numVisible]="5"  >
    <ng-template pTemplate="item" let-item>
        <img [src]="item.itemImageSrc" style="width: 100%;" />
    </ng-template>
    <ng-template pTemplate="thumbnail" let-item>
        <div class="grid grid-nogutter justify-content-center">
            <img class="thumbnail" [src]="item.thumbnailImageSrc" />
        </div>
    </ng-template>
</p-galleria>


<p-dialog [modal]="true" header="Detalle de la imagen" [dismissableMask]="true" [closeOnEscape]="true" [(visible)]="showImageFullScreen" [style]="{width: '95vw', height: '95vh'}">
    <div class="flex justify-content-center align-content-center" *ngIf="showImageFullScreen">
        <img [src]="this.currentImage.itemImageSrc" [style]="{height: '100%'}" />
    </div>
</p-dialog>
